import useImage from 'use-image';
import { Rect } from 'react-konva';

import { HEADER_ROW_HEIGHT } from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { IEmployeeAvatar } from './employee-avatar.interfaces';

const EmployeeAvatar = ({ startPointX, url }: IEmployeeAvatar) => {
  const [image] = useImage(url);

  return (
    <Rect
      x={startPointX + 10}
      y={HEADER_ROW_HEIGHT - 30}
      width={24}
      height={24}
      fillPatternImage={image}
      fillPatternScaleY={24 / (image?.height || 1)}
      fillPatternScaleX={24 / (image?.width || 1)}
      fillPatternX={0}
      fillPatternY={0}
      fillPatternRepeat="no-repeat"
      cornerRadius={12}
    />
  );
};

export default EmployeeAvatar;
